import { useEffect, useState } from 'react';
import { Modal as AntModal } from 'antd';

import { Input } from 'components/common';
import { usePost } from 'hooks';
import { setDynamicsInstance } from 'services/api';

const DynamicsConnectModal = ({ onClose, onConnected, initialServiceUrl }) => {
  const [serviceUrl, setServiceUrl] = useState(initialServiceUrl || '');
  const [{ res, loading, error }, saveInstance] = usePost({
    url: setDynamicsInstance,
  });
  const isEdit = !!initialServiceUrl;

  useEffect(() => {
    if (!res || !res.crmAuthUrl) return;
    window.open(res.crmAuthUrl, '_blank');
    onClose();
    if (onConnected) {
      onConnected();
    }
  }, [res, onConnected, onClose]);

  const handleOk = () => {
    if (!serviceUrl) return;
    saveInstance({ serviceUrl });
  };

  return (
    <AntModal
      open
      width={650}
      title={isEdit ? 'Edit Dynamics 365 Instance URL' : 'Dynamics 365 Sales'}
      onCancel={onClose}
      onOk={handleOk}
      okText={isEdit ? 'Update & Reconnect' : 'Connect'}
      confirmLoading={loading}
      okButtonProps={{ disabled: !serviceUrl || loading }}
    >
      <div style={{ marginBottom: 8, fontWeight: 600 }}>Service URL</div>
      <Input
        placeholder='https://your-org.crm.dynamics.com'
        value={serviceUrl}
        onChange={setServiceUrl}
      />
      {error && (
        <div style={{ marginTop: 8, color: 'red' }}>
          {error.message || 'Unable to start Dynamics authentication.'}
        </div>
      )}
    </AntModal>
  );
};

export default DynamicsConnectModal;
